/**
 * The two "send it another way" steps of the WhatsApp PO handoff, each
 * reporting whether it really happened, so the rail can say when a blocked
 * popup or a refused clipboard sent nothing. (They no longer gate "I sent
 * it" — that in-session gate of 2026-09-17 was removed on 2026-09-21.)
 */

/**
 * Open the supplier's chat in a new tab; false when the browser blocked it.
 *
 * `noopener` is deliberately NOT passed as a window feature: with it, the
 * spec makes window.open return null even when the tab opened, which would
 * make every open look blocked. The opener link is cut by hand instead.
 * (Without `noreferrer` the browser's default policy sends the origin only.)
 */
export function openWhatsAppChat(url: string, windowLike: Pick<Window, "open"> = window): boolean {
  const opened = windowLike.open(url, "_blank");
  if (!opened) return false;
  try {
    opened.opener = null;
  } catch {
    // Already cross-origin: nothing to cut.
  }
  return true;
}

/** Copy text; false when there is no clipboard or it refuses. */
export async function copyText(
  text: string,
  clipboard: Pick<Clipboard, "writeText"> | undefined = typeof navigator === "undefined" ? undefined : navigator.clipboard,
): Promise<boolean> {
  if (typeof clipboard?.writeText !== "function") return false;
  try {
    await clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
